import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FooterOfKalaRaport = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            K_rasedekartonfroshtn,
            K_rasedeKarton,
            K_rasedekartonKren,
            K_rasedekartongarnawa
          } = value;
          return (
            <>
              <br />
              <div className="row ">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">{K_rasedekartonfroshtn}</h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="text-warning">فرۆشتن</h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">{K_rasedekartonKren}</h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="text-warning">کڕین</h3>
                    </div>
                    {/* kalay garawa */}
                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">{K_rasedekartongarnawa}</h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="text-warning">کاڵای گەڕاوە</h3>
                    </div>
                  </div>
                </div>
              </div>
              {/* second row */}
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-4">
                      <h3 className="bg-white tc mt2">
                        {Number(K_rasedeKarton).toFixed(2)}
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning  font-weight-bold ">
                        ڕەسیدی کارتۆن
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              {/* third row */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfKalaRaport;
